import { CustomerProfile } from '../components/CustomerProfile.js';
import { TransactionCard } from '../components/TransactionCard.js';
import { StorylineIntro } from '../components/StorylineIntro.js';
import { StartGameResponse, DecisionLabel } from '../types/index.js';

interface Props {
  session: StartGameResponse;
  currentIndex: number;
  phase: 'intro' | 'playing' | 'submitting';
  aiVsHuman: boolean;
  onBeginPlaying: () => void;
  onDecide: (decision: DecisionLabel) => void;
}

export function GamePage({
  session,
  currentIndex,
  phase,
  aiVsHuman,
  onBeginPlaying,
  onDecide,
}: Props) {

  if (phase === 'intro') {
    return <StorylineIntro storyline={session.storyline} onStart={onBeginPlaying} />;
  }

  if (phase === 'submitting') {
    return (
      <div className="submitting-screen">
        <div className="spinner" />
        <p>Analysing results...</p>
      </div>
    );
  }

  const tx = session.storyline.transactions[currentIndex];
  const aiDecision = session.aiDecisions[currentIndex];

  return (
    <div className="game-layout">
      <CustomerProfile
        profile={session.storyline.customerProfile}
        networkName={session.storyline.networkName}
      />
      <main className="game-main">
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${(currentIndex / 10) * 100}%` }}
          />
        </div>
        <TransactionCard
          key={tx.id}
          transaction={tx}
          index={currentIndex}
          total={10}
          aiDecision={aiVsHuman ? aiDecision : undefined}
          aiVsHuman={aiVsHuman}
          onDecide={onDecide}
        />
      </main>
    </div>
  );
}
